import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class FacePressuresCalculationModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (FacePressuresCalculationModel._instance == null) FacePressuresCalculationModel._instance = new FacePressuresCalculationModel(authManager);
        return FacePressuresCalculationModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'face-pressures/face-pressures-calculations');

        this.entityName = 'face-pressures.FacePressuresCalculation';
        this.privileges = {
            create: [["adminGeotechData"],["manageGeotechData"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"]],
            delete: [["adminGeotechData"],["manageGeotechData"]],
        };

        this.label = 'J S Calculation';
        this.setLabel = 'J S Calculations';

        this.browser = {
            name: 'default-face-pressures-facepressurescalculation-browser',
            moduleName: 'default-face-pressures-facepressurescalculation-browser',
            moduleTitle: 'J S Calculations',
            moduleStateSlotName: 'default-face-pressures-facepressurescalculation-browser',
        };

        this.editor = {
            name: 'default-face-pressures-facepressurescalculation-editor',
            moduleName: 'default-face-pressures-facepressurescalculation-editor',
            moduleTitle: 'J S Calculation',
            moduleStateSlotName: 'default-face-pressures-facepressurescalculation-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'modelSectionId',
                type: 'ModelSection',
                persistent: true,
                label: 'Model Section',
                description: 'only for info (check)',
            },
            {
                name: 'k0CalcMethodId',
                type: 'K0CalculationMethod',
                persistent: true,
                label: 'K 0 Calc Method',
                description: '(coefficient of lateral earth pressure at rest)',
                inEditor: true,
            },
            {
                name: 'kaCalcMethodId',
                type: 'KaCalculationMethod',
                persistent: true,
                label: 'Ka Calc Method',
                description: 'coefficient of lateral earth pressure within silo',
                inEditor: true,
            },
            {
                name: 'k1CalcMethodId',
                type: 'K1CalculationMethod',
                persistent: true,
                label: 'K 1 Calc Method',
                description: 'coefficient of lateral earth pressure within silo',
                inEditor: true,
            },
            {
                name: 'k2CalcMethodId',
                type: 'K2CalculationMethod',
                persistent: true,
                inEditor: true,
            },
            {
                name: 'trCalcMethodId',
                type: 'TrCalculationMethod',
                persistent: true,
                inEditor: true,
            },
            {
                name: 'testingStartAngleZetaCrit',
                type: 'float',
                persistent: true,
                unit: 'deg',
                label: 'Testing Start Angle Zeta Crit',
                description: 'nastavení od jakého úhlu zjišťovat kritický úhel + od jakého úhlu vykreslovat ? Nebo jiná hodnota pro vykreslení ?',
                inEditor: true,
            },
            {
                name: 'testingEndAngleZetaCrit',
                type: 'float',
                persistent: true,
                unit: 'deg',
                label: 'Testing End Angle Zeta Crit',
                description: 'nastavení do jakého úhlu zjišťovat kritický úhel + od jakého úhlu vykreslovat ? Nebo jiná hodnota pro vykreslení ?',
                inEditor: true,
            },
            {
                name: 'testingAngleIncrementZetaCrit',
                type: 'float',
                persistent: true,
                unit: 'deg',
                label: 'Testing Angle Increment Zeta Crit',
                description: 'nastavení incrementu úhlu nebo takto nedělat a výpočet přesněji a vykreslení jinak ?',
                inEditor: true,
            },
            {
                name: 'earthPressureSafetyCoefficientAgainstFaceCollapse',
                type: 'float',
                persistent: true,
                unit: '1',
                label: 'Earth Pressure Safety Coefficient Against Face Collapse',
                inEditor: true,
            },
            {
                name: 'earthPressureSafetyCoefficientAgainstBlowUp',
                type: 'float',
                persistent: true,
                unit: '1',
                label: 'Earth Pressure Safety Coefficient Against Blow Up',
                inEditor: true,
            },
            {
                name: 'groundwaterPressureSafetyCoefficientAgainstFaceCollapse',
                type: 'float',
                persistent: true,
                unit: '1',
                label: 'Groundwater Pressure Safety Coefficient Against Face Collapse',
                inEditor: true,
            },
            {
                name: 'groundwaterPressureSafetyCoefficientAgainstBlowUp',
                type: 'float',
                persistent: true,
                unit: '1',
                label: 'Groundwater Pressure Safety Coefficient Against Blow Up',
                inEditor: true,
            },
            {
                name: 'maximumFacePressureDeviations',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Maximum Face Pressure Deviations',
                inEditor: true,
            },
            {
                name: 'safetyFactorForMaxFacePressure',
                type: 'float',
                persistent: true,
                unit: '1',
                label: 'Safety Factor For Max Face Pressure',
                description: 'HD: Použito v ZTV-ING výpočtu.',
                inEditor: true,
            },
            {
                name: 'slurryUnitWeight',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                label: 'Slurry Unit Weight',
                inEditor: true,
            },
            {
                name: 'surchargeForMinimumRequiredPressureOnly',
                type: 'float',
                persistent: true,
                unit: 'kPa',
                label: 'Surcharge For Minimum Required Pressure Only',
                description: 'udělat tak, aby se surcharge,for,minimum,required,pressure,only vzalo z datasetu nazvaného surcharge,for,minimum,required,pressure,only s tím, že se projdou všechny surcharge a vypočte se suma jejich hodnot (nebo průměrných hodnot, pokud je v jednom datasetu véce hodnot) nad jejich hodnotami z datasetu surcharge,for,minimum,required,pressure,only. Zařídit, aby uživatel mohl změnit název/referenci na dataset s minimálními hodnotami gama. Bude obecně použitelné pro většinu parametrů v geoTypech apod. + max. hodnoty apod.',
                inEditor: true,
            },
        ];

    }

}
